import { create } from "zustand";
import { VaultDownloadNotification } from "../types/companyDocuments";

interface VaultDownloadNotificationState {
  companyId?: string;
  notifications: VaultDownloadNotification[];
  setNotifications: (
    companyId: string,
    notifications: VaultDownloadNotification[]
  ) => void;
  upsertNotification: (
    companyId: string,
    notification: VaultDownloadNotification
  ) => void;
  markRead: (notificationId: string) => void;
  dismissNotification: (notificationId: string) => void;
  clear: () => void;
}

function sortNotifications(notifications: VaultDownloadNotification[]) {
  return [...notifications].sort(
    (first, second) =>
      new Date(second.createdAt).getTime() - new Date(first.createdAt).getTime()
  );
}

export const useVaultDownloadNotificationStore =
  create<VaultDownloadNotificationState>((set) => ({
    companyId: undefined,
    notifications: [],
    setNotifications: (companyId, notifications) => {
      set({ companyId, notifications: sortNotifications(notifications) });
    },
    upsertNotification: (companyId, notification) => {
      set((state) => {
        if (state.companyId && state.companyId !== companyId) {
          return { companyId, notifications: [notification] };
        }
        const withoutCurrent = state.notifications.filter(
          (item) => item.id !== notification.id
        );
        return {
          companyId,
          notifications: sortNotifications([notification, ...withoutCurrent]),
        };
      });
    },
    markRead: (notificationId) => {
      set((state) => ({
        notifications: state.notifications.map((notification) =>
          notification.id === notificationId
            ? {
                ...notification,
                isRead: true,
                readAt: notification.readAt || new Date().toISOString(),
              }
            : notification
        ),
      }));
    },
    dismissNotification: (notificationId) => {
      set((state) => ({
        notifications: state.notifications.filter(
          (notification) => notification.id !== notificationId
        ),
      }));
    },
    clear: () => set({ companyId: undefined, notifications: [] }),
  }));
